<svg width="22" height="2" viewBox="0 0 22 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="3.66667" height="2" fill="CurrentColor"/>
<rect x="4.5835" width="3.66667" height="2" fill="CurrentColor"/>
<rect x="9.1665" width="3.66667" height="2" fill="CurrentColor"/>
<rect x="13.75" width="3.66667" height="2" fill="CurrentColor"/>
<rect x="18.3335" width="3.66667" height="2" fill="CurrentColor"/>
</svg>
